import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CONSTANTS } from '@app/core/constants/constants';
import { appMessageBase } from '@app/core/constants/app-message.constant';
import { SVG_CONST } from '@app/core/constants/svg.constant';
import { getHardRefreshCmd, redirectLandingPage, supportedBrowser } from '@app/core/helpers/utils';
import { AlertPopupComponent, btnCaptionEnum, IAlertPopup, RejectbtnCaptionEnum } from '@app/modules/users/components/alert-popup-dialog/alert-popup.component';
import { JoinSessionComponent } from '@app/modules/users/components/join-session/join-session.component';
import { LoggerService } from '../logger.service';
import { LocalWebRtcService } from '../web-rtc-service/local-webrtc.service';
import { CommonService } from '../common.service';

@Injectable({
  providedIn: 'root'
})
export class CommonAlertService {

  constructor(private readonly dialog: MatDialog,
    private readonly logger: LoggerService,
    private readonly localWebRtcService: LocalWebRtcService,
    private readonly commonService: CommonService
  ) { }

  /**
   * browser support alert
   * @param isGuest 
   * @returns 
   */
  async supportedBrowserAlert(isGuest: boolean = false) {
    try {
      var suppO = await supportedBrowser();
      if (suppO && !suppO.supported) {
        let data: IAlertPopup = {
          title: suppO.title,
          description: suppO.msg,
          isConfirmBox: false,
          image: SVG_CONST.BROWSER_NOT_SUPPORTED,
          isHtml: true,
          isSvgString: true
        }
        const dialogRef = this.dialog.open(AlertPopupComponent, {
          width: CONSTANTS.POPUP_WIDTH.PX_600,
          panelClass: CONSTANTS.POPUP_CLASS.END_SESSION,
          data
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (isGuest) {
            redirectLandingPage();
          }
        });
      }
      return suppO.supported;
    } catch (error) {
      this.logger.error('supportedBrowserAlert', error)
    }
  }

  /**
   * low memory alert 
   * @param description 
   * @param cb 
   */
  async lowMemoryAlert(description: string, cb: (res: boolean) => void) {
    let data: IAlertPopup = {
      title: appMessageBase.lowMemoryTitle,
      description: description,
      isConfirmBox: true,
      image: SVG_CONST.ALERT,
      btnCaption: btnCaptionEnum.proceed,
      isRejectBtn: true,
      rejectBtnCaption: RejectbtnCaptionEnum.cancel,
      isHtml: true,
      isSvgString: true
    }
    const dialogRef = this.dialog.open(AlertPopupComponent, {
      width: CONSTANTS.POPUP_WIDTH.PX_600,
      panelClass: CONSTANTS.POPUP_CLASS.END_SESSION,
      data
    });
    dialogRef.afterClosed().subscribe((result) => {
      cb(result);
      // if (result) {
      //   this.ManageSession(session)
      // }
    });
  }

  /**
   * join session alert
   * @param cb 
   * @param isGuest 
   */
  joinSessionPerformaceTipsAlert(isGuest = false): Promise<boolean> {
    return new Promise((res: any, rej: any) => {
      const dialogRef = this.dialog.open(JoinSessionComponent, {
        panelClass: 'full-dialog-container',
        data: {
          isGuest
        }
      });
      const sub = dialogRef.afterClosed().subscribe((result) => {
        sub.unsubscribe();
        res(result);
      });
    })
  }

  /**
   * display when we push new build on api version
   * msg: A new Boomcaster version (1.x.x) has arrive. Press Control + F5 to update.
   */
  async newVersion() {
    await supportedBrowser();
    const cmd = getHardRefreshCmd();
    let data: IAlertPopup = {
      title: 'New Version',
      description: `Press ${cmd} to reload the browser and apply the update`,
      image: SVG_CONST.NEW_BUILD,
      isRejectBtn: true,
      rejectBtnCaption: RejectbtnCaptionEnum.dismiss,
      isSvgString: true
    }
    const dialogRef = this.dialog.open(AlertPopupComponent, {
      width: CONSTANTS.POPUP_WIDTH.PX_600,
      panelClass: CONSTANTS.POPUP_CLASS.END_SESSION,
      data
    });
  }

  /**
   * check and show  private winodw popup
   * @returns 
   */
  async privateWindow() {
    return new Promise(async (res: any, rej: any) => {
      console.log('privateWindow CHECK');
      let isTest = false;
      try {
        isTest = localStorage.getItem('TEST-CONF') === "true";
      } catch { }
      try {
        this.commonService.startLoader();
        const isPrivate = await this.localWebRtcService.isPrivateWindow();
        if (isPrivate && !isTest) {
          let data: IAlertPopup = {
            title: appMessageBase.privateWindowTitle,
            description: appMessageBase.privateWindowDescription,
            isConfirmBox: false,
            image: SVG_CONST.BROWSER_NOT_SUPPORTED,
            isHtml: true,
            isSvgString: true
          }
          const dialogRef = this.dialog.open(AlertPopupComponent, {
            width: CONSTANTS.POPUP_WIDTH.PX_600,
            panelClass: CONSTANTS.POPUP_CLASS.END_SESSION,
            data
          });
          dialogRef.afterClosed().subscribe((result) => {
            this.commonService.stopLoader();
            res(true);
          });
        }
        else {
          this.commonService.stopLoader();
          res(false);
        }
      } catch (error) {
        this.commonService.stopLoader();
        rej(error);
      }
    })
  }
}
